<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">

    <el-select
      :value="value"
      :clearable="clearable"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :multiple="multiple"
      :value-key="itemValue"
      :remote="remote"
      :remote-method="remoteMethod"
      @change="setEvent('input', $event)"
      @input="setEvent('input', $event)"
      collapse-tags
      filterable
    >
      <template v-if="itemGroup">
        <el-option-group
          v-for="(item,indexItem) in items"
          :key="indexItem"
          :label="getLabel(item)"
          :disabled="disabled"
        >
          <el-option
            v-for="(subItem,indexSubItem) in item.options"
            :key="indexItem+indexSubItem"
            :label="getLabel(subItem)"
            :value="getValue(subItem)"
            :disabled="disabled"
          >
            <span v-html="getHtml(subItem)"></span>
          </el-option>
        </el-option-group>
      </template>

      <template v-else>
        <el-option
          v-for="(item, index) in items"
          :key="index"
          :label="getLabel(item)"
          :value="getValue(item)"
        >
          <span v-html="getHtml(item)"></span>
        </el-option>
      </template>
    </el-select>
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputAutoComplete",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id",
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome",
    },
    itemGroup: {
      type: [Boolean],
      required: false,
      default: null,
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false,
    }
  },
  data() {
    return {
      search: null,
      timerId: null,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },
  computed: {},
  methods: {

    remoteMethod(val) {
      this.$emit("search", val);
    },

    // remoteMethod: _.debounce(function (val) {

    //   if(val){
    //     this.$emit("search", val);
    //   }

    // }, 1000),

    getLabel(item) {

      let itemText = (item.itemText ? item.itemText : this.itemText)

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM "+this.$utilidade.toDate(item.vencimento,true)+")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo
          break;

        case "tabela_dinamica":
          return item.nome;
          break;

        default:
          return item[this.itemText];
          break;
      }
    },

    getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },

    getHtml(item) {

      let itemText = (item.itemText ? item.itemText : this.itemText)

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM "+this.$utilidade.toDate(item.vencimento,true)+")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo
          break;

        case "tabela_dinamica":
            return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + item.cor + '">&nbsp;</span>' + item.nome;
            break;
        case "fator_risco":
        
            return (
              "<b>" + item.nome + "</b>" 
              + (item.cod_esocial ? '<br><span style="font-size:9pt">' + item.cod_esocial + "</span>" : "") 
              + (item.cod_metodologia && item.cod_metodologia != "***" ? (!item.cod_esocial ? "<br>" : "") 
              + '<span style="font-size:9pt"> (' + item.cod_metodologia + ")</span>" : "")
            );
            break;

        default:
          return item[this.itemText];
          break;
      }
    },
  },
  watch: {
    items() {},
  },
};
</script>



// WEBPACK FOOTER //
// EdInputSelect.vue?763f9b54